import { Pipe, PipeTransform } from '@angular/core';
import { FullNamePipe } from './full-name.pipe';
import { PossessivePipe } from './possessive.pipe';

/*
 * Format the Guardian Address to be used in templates if the Address is not null
 * Takes an index of the Guardian in the array to append to the name
 * Usage:
 *   value | addressOrName:currentIdx
 * Example:
 *   {{ guardian }}
 *   formats to: 123 Test Lane or Guardian 1's address if address was null
 */

@Pipe({
    name: 'addressOrName',
    standalone: true
})
export class AddressOrNamePipe implements PipeTransform {
	constructor(
		private fullNamePipe: FullNamePipe,
		private possessivePipe: PossessivePipe
	) {}

	transform(value: any): string {
		if (value && value.address) {
			if (value.address.trim() !== '') {
				return value.address + '**REMOVE PLACEHOLDER2**';
			}
		}
		const fullName = this.fullNamePipe.transform(value, value.internalGuardianDisplayIdx - 1);
		const possessiveName = this.possessivePipe.transform(fullName);
		return possessiveName;
	}
}
